import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatBar from '../components/ChatBar';
import PolicyLayout from './PolicyLayout';
import {
  ADDRESS,
  COMPANY_NAME,
  POLICY_UPDATED,
  SITE_DOMAIN,
  SITE_NAME,
} from '../constants/site';

export default function PrivacyPolicy() {
  return (
    <div className="page">
      <Header />
      <PolicyLayout
        title="Privacy Policy"
        updated={POLICY_UPDATED}
        intro={`${COMPANY_NAME} ("we", "us") operates ${SITE_NAME} at ${SITE_DOMAIN}. This Privacy Policy explains how we collect, use, and protect information when you use our website.`}
      >
        <h2>Information we collect</h2>
        <p>
          We may collect your name, email address, phone number, and message content when you
          submit a query form, call us, or use live chat. We may also collect technical data such as
          IP address, browser type, device type, and pages visited for security and analytics.
        </p>

        <h2>How we use information</h2>
        <p>
          We use collected information to respond to your requests, provide support, improve our
          website, maintain security, and comply with legal obligations.
        </p>

        <h2>Cookies and third-party services</h2>
        <p>
          We may use cookies and similar technologies for session management and analytics. Live chat
          is provided through a third-party service that may process limited data on our behalf.
        </p>

        <h2>Data retention and security</h2>
        <p>
          We retain personal information only as long as needed for the purposes described above.
          We use reasonable safeguards to protect data, though no online transmission is completely
          secure.
        </p>

        <h2>Your rights</h2>
        <p>
          Depending on applicable law, you may request access, correction, or deletion of your
          personal information by contacting us using the details below.
        </p>

        <h2>Contact</h2>
        <p>
          {COMPANY_NAME}<br />
          {ADDRESS}<br />
          Website: {SITE_DOMAIN}
        </p>
      </PolicyLayout>
      <Footer />
      <ChatBar />
    </div>
  );
}
